export default __webpack_public_path__ + "static/media/300.288787f6.woff";